// Bootstrap draws a breadcrumb divider as the item's ::before, so a wrapped row of
// publication years opens with a bullet. Only layout knows which item starts a row.
const YEARS = '#breadcrumbs .breadcrumb-years';
const LINE_START = 'breadcrumb-line-start';

let observer = null;
let queued = false;

function markLineStarts(list) {
  let lineTop = null;
  Array.from(list.children).forEach((item) => {
    const { top } = item.getBoundingClientRect();
    // 1px absorbs subpixel drift between items sharing a row.
    const starts = lineTop === null || top - lineTop > 1;
    item.classList.toggle(LINE_START, starts);
    if (starts) {
      lineTop = top;
    }
  });
}

function watch(list) {
  if (!window.ResizeObserver) {
    return;
  }
  if (observer) {
    observer.disconnect();
  }
  // The class only hides a divider, it never resizes one, so this cannot feed itself.
  observer = new ResizeObserver(() => {
    if (queued) {
      return;
    }
    queued = true;
    // Coalesce a burst of resizes into one pass, after the frame that caused them.
    window.requestAnimationFrame(() => {
      queued = false;
      markLineStarts(list);
    });
  });
  observer.observe(list);
}

export default () => {
  apos.util.onReady(() => {
    const list = document.querySelector(YEARS);
    if (!list) {
      return;
    }
    markLineStarts(list);
    watch(list);
  });
};
